// src/components/helpers/ScholarshipBookPDF.js
import React from "react";

import { StyleSheet } from "@react-pdf/renderer"; // regular import

import { Document, Page, Text, View, Image } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    lineHeight: 1.5,
    fontFamily: "Helvetica",
  },
  header: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 20,
  },
  logo: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: 250,
  },
  capImage: {
    textAlign: "center",
    width: 150,
    marginBottom: 5,
  },
  yearText: {
    fontSize: 16,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    marginBottom: 25,
  },
  mainTitle: {
    fontSize: 16,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    marginBottom: 10,
    whiteSpace: "pre-wrap",
  },
  marginLine: {
    marginTop: 20,
  },
  repTitle: {
    fontSize: 16,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    marginBottom: 8,
  },
  repText: {
    fontSize: 16,
    marginBottom: 7,
    textAlign: "center",
    whiteSpace: "pre-wrap",
    fontFamily: "Helvetica",
    fontWeight: 350,
  },
  onlineText: {
    fontSize: 16,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    marginTop: 20,
    marginBottom: 20,
    textAlign: "center",
  },
  awardsPage: {
    paddingVertical: 22.5,
    paddingHorizontal: 30,
    paddingLeft: 45,
    fontSize: 10,
    lineHeight: 1.5,
    fontFamily: "Helvetica",
  },
  pageHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 7,
  },
  pageHeaderLogo: {
    width: 150,
  },
  pageHeaderTitle: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    marginBottom: 5,
    textAlign: "center",
  },
  horizontalLine: {
    borderBottomWidth: 0.5,
    borderBottomColor: "#000",
    marginTop: 7,
    marginBottom: 10,
  },
  awardContainer: {
    marginBottom: 15,
    paddingLeft: 15,
  },
  awardName: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    marginBottom: 6,
  },
  awardDetails: {
    fontSize: 12,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    marginBottom: 4,
  },
  prioritiesView: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  prioritiesTitle: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    marginBottom: 1,
  },
  priorities: {
    fontSize: 10,
    marginBottom: 1,
  },
  additionalInfo: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    color: "red",
    marginBottom: 1,
  },
  descriptionHeader: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    marginBottom: 1,
  },
  description: {
    fontSize: 9.5,
    marginLeft: 10,
    marginBottom: 15,
    textAlign: "justify",
  },
  footer: {
    paddingLeft: 45,
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40,
    textAlign: "center",
    fontSize: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

const Footer = ({ pageNumber = "0" }) => (
  <View style={styles.footer}>
    <Text style={styles.footerText}>NLSF Awards</Text>
    <Text>{`Page #${pageNumber}`}</Text>
    <Text>{`Generated: ${new Date().toLocaleString()}`}</Text>
  </View>
);

const TitlePage = ({ city, startYear, endYear }) => {
  return (
    <Page size="LETTER" style={styles.page}>
      <View style={styles.header}>
        <Image
          src="https://sas.nlsf.ca/nlsf-scholarships.png"
          style={styles.logo}
        />
        {/* Cap Image */}
        <Image src="https://sas.nlsf.ca/cap.png" style={styles.capImage} />
        {/* Year */}
        <Text style={styles.yearText}>{`${startYear}/${endYear}`}</Text>
        {/* Main Title (with line breaks) */}
        <Text style={styles.mainTitle}>SCHOLARSHIPS</Text>
        <Text style={styles.mainTitle}>BURSARIES</Text>
        <Text style={styles.mainTitle}>AWARDS</Text>
        <View style={styles.marginLine}></View>
        {/* Conditional representation */}
        {city === "Nanaimo" ? (
          <>
            <Text style={styles.repTitle}>Representing:</Text>
            <Text style={styles.repText}>Dover Bay Secondary School</Text>
            <Text style={styles.repText}>
              John Barsby Community Secondary School
            </Text>
            <Text style={styles.repText}>Learning Alternatives</Text>
            <Text style={styles.repText}>
              Nanaimo District Secondary School
            </Text>
            <Text style={styles.repText}>Wellington Secondary School</Text>
            <Text style={styles.repText}>Cedar Secondary School</Text>
            <Text style={styles.repText}>IslandConnectED</Text>
          </>
        ) : (
          <Text style={styles.repText}>Ladysmith Secondary School</Text>
        )}
        {/* Online Notice */}
        <Text style={styles.onlineText}>
          Scholarship Booklet is online @ www.NLSF.ca
        </Text>
      </View>
    </Page>
  );
};

const AwardsPage = ({ awardsChunk, city, currentYear, pageNumber }) => {
  return (
    <Page size="LETTER" style={styles.awardsPage}>
      {/* Header for subsequent pages */}
      <View style={styles.pageHeader}>
        <Text style={styles.pageHeaderTitle}>
          {`Scholarship Book ${currentYear} - ${city} Awards`}
        </Text>
        <Image
          src="https://sas.nlsf.ca/nlsf-scholarships.png"
          style={styles.pageHeaderLogo}
        />
      </View>
      <View style={styles.horizontalLine} />
      {awardsChunk?.map((award) => (
        <View key={award?.id} style={styles.awardContainer}>
          <Text style={styles.awardName}>{award?.scholarship}</Text>
          <Text style={styles.awardDetails}>
            {award?.number_of_awards}{" "}
            {award?.number_of_awards !== "1"
              ? award?.award_type === "Bursary"
                ? "Bursaries"
                : award?.award_type + "s"
              : award?.award_type}{" "}
            @{" "}
            {Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(award?.award_amount)}
          </Text>
          {(award?.priority1 || award?.priority2 || award?.priority3) && (
            <View style={styles.prioritiesView}>
              <Text style={styles.prioritiesTitle}>Priorities: </Text>
              <Text style={styles.priorities}>
                {`${award?.priority1 || ""} ${award?.priority2 || ""} ${
                  award?.priority3 || ""
                }`}
              </Text>
            </View>
          )}
          {(award?.additional_info_needed === true ||
            award?.additional_info_needed === "True") && (
            <Text style={styles.additionalInfo}>
              Additional Info Is Required
            </Text>
          )}
          <Text style={styles.descriptionHeader}>Award Description:</Text>
          {award?.name_line_2 && (
            <Text style={styles.description}>{award.name_line_2}</Text>
          )}
          <Text style={styles.description}>{award?.description}</Text>
        </View>
      ))}
      <Footer pageNumber={pageNumber} />
    </Page>
  );
};

const ScholarshipBookPDF = ({ data, city }) => {
  const currentYear = new Date().getFullYear();
  const startYear = new Date().getMonth() > 9 ? currentYear : currentYear - 1;
  const endYear = startYear + 1;

  const chunkSize = 3;
  const awardsChunks = [];
  if (data && data?.length > 0) {
    for (let i = 0; i < data?.length; i += chunkSize) {
      awardsChunks.push(data?.slice(i, i + chunkSize));
    }
  }

  return (
    <Document>
      {/* Title Page */}
      <TitlePage city={city} startYear={startYear} endYear={endYear} />
      {awardsChunks?.map((chunk, index) => (
        <AwardsPage
          key={index}
          awardsChunk={chunk}
          city={city}
          currentYear={currentYear}
          pageNumber={index + 2}
        />
      ))}
    </Document>
  );
};

export default ScholarshipBookPDF;
